import * as server from "@/utils/http"


// 获取业务类型
export const _getBusinessTypes=params=> server.get("/business-type/findAll",params)
